// Build-time configuratie. esbuild vervangt deze waarden via --define,
// gevoed uit .env of uit de omgevingsvariabelen van Netlify.
//
// De anon key mag publiek zijn, maar alleen zolang RLS op elke tabel aanstaat.
// Zie docs/fase-0-audit.sql voordat je dit gelooft.

export const SUPABASE_URL = __SUPABASE_URL__;
export const SUPABASE_ANON_KEY = __SUPABASE_ANON_KEY__;
export const PRIMARY_ADMIN = __PRIMARY_ADMIN__;
export const APP_ENV = __APP_ENV__;
